import * as React from 'react'
import { omit, mapValues, get } from 'lodash'
import InputField from '../../common/components/input-field'
import StandardInput from '../../common/components/standard-input'
import SelectionInput from '../../common/components/selection-input'
import SuburbAutoComplete from '../../common/components/suburb-auto-complete'
import YesNoInput from '../../common/components/yes-no-input'
import DatePicker from '../../common/components/date-picker'
import Validation from '../../common/modules/validation/rules'
import AddressPicker from '../../common/components/address-picker'
import Message from '../../common/components/message'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import Button from '../../common/components/button'
import QuoteNumber from '../../common/components/quote-number'
import yesNoOptions from '../../common/options/yes-no-options'
import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withNavigation } from '../../common/modules/navigation'
import { withFields } from '../../common/modules/fields'
import { withProductData } from '../../common/modules/product-data'
import { withState } from '../../common/modules/state'
import { withAddressValidation } from '../../common/modules/address-validation'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { withConfig } from '../../common/modules/config';
import { withErrors } from '../../common/modules/errors'
import { ClaimRows, ExcessRows } from '../components/duty-of-disclosure-rows'
import {
    CLAIM_ROWS_REQUIRED,
    EXCESS_ROWS_REQUIRED,
    claimExcessTypeOptions,
    claimTotals,
    simplifiedQuotingRequestFields,
} from '../simplified-quoting'


export const formConfig = state => {
    const fields = state.fields;
    const productData = state.productData;
    const addressValidation = state.addressValidation;

    const manualAddress = !!state.fields.addressNotFound /* || state.fields.__firstAddressAsk__*/

    return {
        rules: {
            currentInsurer:[
                Validation.enforce.required("Please select your current insurer"),
            ],
            otherInsurer:[
                Validation.enforce.required("Name of your current insurer"),
            ],
            startDate:[
                Validation.enforce.required("Please tell us when your current policy expires. This cannot be more than 30 days in the future"),
                Validation.enforce.date("Please tell us when your current policy expires. This cannot be more than 30 days in the future"),
            ],
            currentExcess:[
                Validation.enforce.required("Enter excess of your current policy"),
                Validation.enforce.number("The amount must be a whole dollar value"),
            ],
            __hasClaims__:[
                Validation.enforce.isTrueOrFalse("Please answer the Duty of Disclosure question"),
            ],
            claimsHistoryDetailApi:[
                Validation.enforce.hasAtLeastOneEntry(CLAIM_ROWS_REQUIRED),
            ],
            propertyInsuranceDeclined:[
                Validation.enforce.required("Please answer the Duty of Disclosure question"),
            ],
            coverLimited:[
                Validation.enforce.required("Please answer the Duty of Disclosure question"),
            ],
            excessHistory:[
                Validation.enforce.isTrueOrFalse("Please answer the Duty of Disclosure question"),
            ],
            excessHistoryDetails:[
                Validation.enforce.hasAtLeastOneEntry(EXCESS_ROWS_REQUIRED),
            ],
            ownersCorporationNumber:[
                Validation.enforce.required("Please enter Owners Corporation Number"),
                Validation.enforce.ownersCorporationNumber("Owners Corporation numbers should have a maximum of 9 digits, and optionally followed by two characters. Northern Territory Owners Corporation number must have 1 to 4 digits, '/' followed by 1 to 4 digits.")
            ],
            ownersCorporationType: [
                Validation.enforce.required("Please select a value"),
            ],


            addressNotFound: [],
            streetAddress: !manualAddress ? [ Validation.enforce.required("Please enter a street address") ] : [],
            
            "ownersCorporationAddress.streetNumber": !manualAddress ? [] : [ Validation.enforce.required("Please provide the street number")],
            "ownersCorporationAddress.streetName": !manualAddress ? [] : [ Validation.enforce.required("Please provide the street name")],
            "ownersCorporationAddress.suburb": !manualAddress ? [] : [ Validation.enforce.required("Please provide the suburb")],
            "ownersCorporationAddress.postcode":[
                Validation.enforce.required("Please provide the postcode"),
            ],
            "ownersCorporationAddress.state":  !manualAddress ? [] : [Validation.enforce.required("Please provide the state")],
            selfManaged:[
                Validation.enforce.required("Please tell us if your property is managed by a strata company"),
            ],
        },
        predicates: {
            claimsHistoryDetailApi: fields.__hasClaims__ === true,
            excessHistoryDetails: fields.excessHistory === true,
            otherInsurer: fields.currentInsurer === "OTHER",
            ownersCorporationType: get(fields, "ownersCorporationAddress.state") === "VIC",
            currentExcess: fields.currentInsurer !== "NOT_CURRENTLY_INSURED" && fields.currentInsurer !== "NOT_KNOWN" && fields.currentInsurer !== "NEW_STRATA_PLAN",
        },
        options:{
            currentInsurer: productData.productOptions.INSURER,
            ownersCorporationType: productData.productOptions.OWNERS_CORP_TYPE,
            propertyInsuranceDeclined: yesNoOptions,
            coverLimited: yesNoOptions,
            excessHistory: yesNoOptions,
            __hasClaims__: yesNoOptions,
            selfManaged: yesNoOptions,
            'ownersCorporationAddress.state':[
                { label:'NSW', value: 'NSW' },
                { label:'VIC', value: 'VIC' },
                { label:'QLD', value: 'QLD' },
                { label:'WA', value: 'WA' },
                { label:'ACT', value: 'ACT' },
                { label:'NT', value: 'NT' },
                { label:'TAS', value: 'TAS' },
            ],
        },
        inferred:{},

        transformOut: data => ({
            ...omit(data, ['__hasClaims__']),
            ...simplifiedQuotingRequestFields(fields),
        })
    }
}


@withAddressValidation
@withSubmission
@withNavigation
@withProductData
@withValidation
@withErrors
@withFields
@withRouteBlocker
@withScrollToTop
@withConfig
@withForm(formConfig)
export default class extends React.Component<any, any> {

    componentWillMount(){
        console.log("Mounting step-2");
    }

    componentDidMount(){
        this.restoreClaimsAnswer();
    }

    componentDidUpdate(){
        this.restoreClaimsAnswer();
    }

    restoreClaimsAnswer(){
        const fields = this.props.fields;
        const rows = fields.claimsHistoryDetailApi;
        if (fields.__hasClaims__ !== true && fields.__hasClaims__ !== false && rows && rows.length > 0) {
            this.props.actions.fields.updateField('__hasClaims__', true);
        }
    }

    render() {
        const addressNotFound = this.props.fields.addressNotFound
        const fields = this.props.fields

        return (
            <div className="row">
                <StepTitle>Tell Us About Your Current Insurance</StepTitle>	
                <QuoteNumber />

                <InputField   field="currentInsurer"     type="String"     label="Who are you currently insured with?"         />
                <InputField   field="otherInsurer"       type="String"     label="Name of your current insurer"                />
                <InputField   field="startDate"          type="Date"       label="When do you want cover to commence?"         endDate='+90d'/>
                <InputField   field="currentExcess"      type="Currency"   label="What is the excess on your current policy?"  />


                <SubHeader>Your Duty of Disclosure</SubHeader>

                <InputField   field="propertyInsuranceDeclined"    type="Boolean"    label="Has insurance on this property been declined in the past three (3) years?"        />
                <InputField   field="coverLimited"                 type="Boolean"    label="Has the cover under your existing policy been limited or restricted in any way?"   />
                <InputField   field="excessHistory"                type="Boolean"    label="Has your current policy had any additional excesses imposed?"                     />
                <ExcessRows
                    visible={fields.excessHistory === true}
                    rows={fields.excessHistoryDetails}
                    options={claimExcessTypeOptions(this.excessTypeOptions())}
                    errors={this.props.errors && this.props.errors.excessHistoryDetails}
                    onChange={rows => this.props.actions.fields.updateField('excessHistoryDetails', rows)}
                />
                <InputField   field="__hasClaims__" type="Boolean" label="Have you had any claims in the past three (3) years?" />
                <ClaimRows
                    visible={fields.__hasClaims__ === true}
                    rows={fields.claimsHistoryDetailApi}
                    options={claimExcessTypeOptions(this.excessTypeOptions())}
                    startDate={fields.startDate}
                    errors={this.props.errors && this.props.errors.claimsHistoryDetailApi}
                    onChange={rows => {
                        const totals = claimTotals(rows)
                        this.props.actions.fields.updateFields({
                            claimsHistoryDetailApi: rows,
                            numberOfClaims: totals.numberOfClaims,
                            valueOfClaims: totals.valueOfClaims,
                        })
                    }}
                />

                { /*
                <SubHeader>Tell us where you want to insure</SubHeader>

                <InputField   field="ownersCorporationAddress.streetNumber"    type="String"     label="Street Number"           size="col-sm-3"  />
                <InputField   field="ownersCorporationAddress.streetName"      type="String"     label="Street Name"             size="col-sm-9"  />
                <InputField   field="ownersCorporationAddress.suburb"          type="SuburbAuto" label="Suburb/Town"             size="col-sm-6"  stateField="ownersCorporationAddress.state"   postcodeField="ownersCorporationAddress.postcode"/>
                <InputField   field="ownersCorporationAddress.state"           type="String"     label="State"                   size="col-sm-3"  enabled={ false } />
                <InputField   field="ownersCorporationAddress.postcode"        type="String"     label="Postcode"                size="col-sm-3"  enabled={ false } />
                */}
                
                <SubHeader id="address-scroll-point">Tell us where you want to insure</SubHeader>

                { !addressNotFound && <InputField field="ownersCorporationAddress.postcode"      label="Postcode"        size="col-md-3"  type="number" /> }
                { !addressNotFound && <InputField field="streetAddress" label="Street address"  size="col-md-8"  addressNotFoundField="addressNotFound" type="PostcodeAuto" postcodeField='ownersCorporationAddress.postcode' streetNumberField="ownersCorporationAddress.streetNumber" streetNameField="ownersCorporationAddress.streetName" suburbField="ownersCorporationAddress.suburb" stateField="ownersCorporationAddress.state"/> }

                {this.props.fields.addressNotFound || !this.props.fields.quoteNumber && <SubHeader>Sorry we couldn't find your address, please enter it manually:</SubHeader> }
                { addressNotFound && <InputField field="ownersCorporationAddress.streetNumber"  label="Street number"   size="col-md-3" /> }
                { addressNotFound && <InputField field="ownersCorporationAddress.streetName"    label="Street name"     size="col-md-9" /> }
                { addressNotFound && <InputField field="ownersCorporationAddress.suburb"        label="Suburb/Town"     size="col-md-6" /> }
                { addressNotFound && <InputField field="ownersCorporationAddress.state"         label="State"           size="col-md-3" /> }
                { addressNotFound && <InputField field="ownersCorporationAddress.postcode"      label="Postcode"        size="col-md-3" type="number" /> }


                <SubHeader>Tell Us About Your Owners Corporation</SubHeader>


                <InputField    field="ownersCorporationNumber"                  type="String"     label="Owners Corporation Number"               inline={ true }   help={<span><p>Please do not input prefixes before the plan number - e.g. for 'SP12345' enter '12345 'and for 'PS654321G' enter '654321G'.</p><p>We cannot provide you a quote without a valid Owners Corporation number. A sales representative will be in touch to confirm the correct Owners Corporation number within the next business day once you complete this quote.</p></span>}/>
                <InputField    field="ownersCorporationType"                    type="String"     label="What is your Owners Corporation type?"   inline={true}  />

                
                <InputField    field="selfManaged"                              type="String"     label="Is the property managed by a strata company?"       reverse={ true } />

                <Button.Container>
                    <Button.Back route="/step-1" /> <Button.Continue onClick={ this.validate.bind(this)} />
                </Button.Container>

            </div>

        )
    }


    excessTypeOptions(){
        const productOptions = this.props.productData && this.props.productData.productOptions
        return productOptions && productOptions.DOD_CLAIM_EXCESS_TYPE
    }


    addStreetAddressErrors(){
        this.props.actions.errors.setErrors({
            ...this.props.errors,
            streetAddress: ["Please select an option"]
        })
    }


    validate(){
        const fields = this.props.fields;
        if(!fields.addressNotFound && (!fields.ownersCorporationAddress.streetNumber || !fields.ownersCorporationAddress.streetName || !fields.ownersCorporationAddress.suburb || !fields.ownersCorporationAddress.state || !fields.ownersCorporationAddress.postcode)){    
            this.props.actions.validation.validate(this.addStreetAddressErrors.bind(this));
        }else{
            this.props.actions.validation.validate( this.proceed.bind(this) );
        }
    }


    /*
    validate(){
        console.log(this.props)
        this.props.actions.validation.validate( this.validateAddress.bind(this) );
    }


    validateAddress(){
        this.props.actions.addressValidation.validateAddress( this.proceed.bind(this), null, "ownersCorporationAddress.streetNumber", "ownersCorporationAddress.streetName", "ownersCorporationAddress.suburb", "ownersCorporationAddress.state", "ownersCorporationAddress.postcode" );
    }
    */


    proceed(){
        // Google analytics tracking
        const config = this.props.config;

        window["dataLayer"].push({
            'event' : 'gaEvent' ,
            'eventCategory' : 'quote forms' ,
            'eventAction' : config.project + ' quote created' , // Type of quote created
            'eventLabel' : this.props.fields.quoteNumber , // Quote number created
            'eventValue' : null ,
            'eventNonInteraction' : true
    });

       this.props.actions.navigation.changeRoute("/step-3")
    }


}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/strata/routes/step-2.tsx